import { ApiMethods, ApiTags, appAPI } from '.';

export interface AuditLog {
  id: string;
  createdAt: string;
  actorId?: string;
  actorType?: string;
  actorRole?: string;
  companyId?: string;
  source: string;
  eventType: string;
  eventDescription: string;
  context?: Record<string, unknown>;
  userAgent?: string;
  ip?: string;
}

interface ListAuditLogsParams {
  limit?: number;
  nextToken?: string;
  startDate?: string;
  endDate?: string;
  actorId?: string; // comma separated list of actor ids
  eventType?: string; // comma separated list of event types
}

interface ListAuditLogsResponse {
  data: AuditLog[];
  nextToken?: string;
}

export const auditLogApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    listAuditLogs: build.query<ListAuditLogsResponse, ListAuditLogsParams>({
      query: (params) => {
        const qs = new URLSearchParams();
        if (params.limit != null) qs.set('limit', String(params.limit));
        if (params.nextToken) qs.set('nextToken', params.nextToken);
        if (params.startDate) qs.set('startDate', params.startDate);
        if (params.endDate) qs.set('endDate', params.endDate);
        if (params.actorId) qs.set('actorId', params.actorId);
        if (params.eventType) qs.set('eventType', params.eventType);
        return {
          path: `/events?${qs.toString()}`,
          method: ApiMethods.get,
          options: {},
        };
      },
      providesTags: [{ type: ApiTags.auditLogs, id: 'LIST' }],
    }),
  }),
});

export const { useListAuditLogsQuery } = auditLogApi;
